export function formatName(user) {
  if (!user) {
    return '';
  }

  if (user.firstName !== '') {
    return `${user.firstName} ${user.lastName}`;
  }

  return user.username;
}
